module.exports = __webpack_public_path__ + "img/plus_pre.95741186.png";